import React from "react";
import { connect } from "react-redux";
import DriveItemTemplate from "../driveItemTemplate/DriveItemTemplate";
import Moment from "moment";
import 'moment/min/moment-with-locales'
import 'moment/min/locales';
import Tooltip from "../driveItemThumbnail/TooltipsPage";
import parameters from "../../../config/parameters";
import Wix from 'Wix';
import "./DriveItemList.scss";


class DriveItemList extends DriveItemTemplate {
  render() {
    const dateTime = this.state.item.modifiedDate;
    const locale = Wix.Utils.getLocale() || 'en';
    Moment.locale(locale);
    const iscurrentDate = Moment(dateTime).isSame(new Date(), "day")?
                          Moment(dateTime).format("HH:mm a"):
                          Moment(dateTime).format("ll");
    const ownerName = this.state.item.ownerNames[0] === this.props.userName ? "me": this.state.item.ownerNames[0];
    if (!this.state.item) return <div />;
    //else if (this.props.signal) return this.renderItemFullScreen(false);
    else
      return (
        <div >

        <div
          key={this.state.item.id}
          className="item-list"
          onClick={this.openItem}
        >
          {this.state.clicked ? this.renderItemFullScreen(true) : null}
          <div className="item">
            <div className={!this.state.displayOwner || !this.state.displayLastModified ? "name-list title-item name-list-2": "name-list title-item"}>
                <div/>
                      <div style={{ width: "24px" }}>
                      {this.state.displayIcon || this.state.item.mimeType === parameters["TYPE_FOLDER"] ? (
                        <div className="div-icon">
                          <img
                            className="icon"
                            alt="icon"
                            src={this.state.item.iconLink}
                          />
                        </div>
                      ) : null}
                    </div>


                  <Tooltip text={this.state.item.title} className={"name-item  overflow-name " + (this.state.displayIcon || this.state.item.mimeType === parameters["TYPE_FOLDER"] ? "name-item-margin" : "")} />
            </div>
            {this.state.displayOwner ?
            <div className={!this.state.displayLastModified ? "owner-list owner-list-2 overflow-name": "owner-list overflow-name"} >
                <Tooltip text={ownerName} className="owner-item overflow-name" />
            </div> : null}
            {this.state.displayLastModified ?
            <div className="last-modified-item">
                 {iscurrentDate}
            </div>
            : null}
          </div>
          <div className="last-modified-mobile">
           {this.state.displayIcon || this.state.item.mimeType === parameters["TYPE_FOLDER"] ? <div style={{ width: "16%" }} /> : null}
            <div className="last-modified-item-mobile">
            {this.state.displayOwner && !this.state.displayLastModified ?
                ownerName : this.state.displayLastModified && this.state.displayOwner
                  ? <div><span>{ownerName}</span>
                    <span>,&nbsp;&nbsp;</span>
                    <span>{iscurrentDate}</span></div>
                  : this.state.displayLastModified ? iscurrentDate: ''}
            </div>
          </div>
        </div>
        <hr    className="divider-row divider-row-color"/>
        </div>
      );
  }
}

const mapStateToProps = state => ({
  canEdit: state.widgetReducer.canEdit,
  userName: state.widgetReducer.userName
});

export default connect(mapStateToProps)(DriveItemList);



// WEBPACK FOOTER //
// ./src/widget/components/driveItemList/DriveItemList.js